import React, { useEffect, useRef, useState } from 'react';
import { Check, Copy } from 'lucide-react';
import { btnSecondary } from './ui';

async function copyText(text) {
  try {
    await navigator.clipboard.writeText(text);
    return true;
  } catch (_) {
    // Older browsers / non-secure origins.
    const area = document.createElement('textarea');
    area.value = text;
    area.setAttribute('readonly', '');
    area.style.position = 'fixed';
    area.style.opacity = '0';
    document.body.appendChild(area);
    area.select();
    let ok = false;
    try { ok = document.execCommand('copy'); } catch (__) { ok = false; }
    document.body.removeChild(area);
    return ok;
  }
}

/** Outlined Copy button that reads "Copied" for two seconds after success (DESIGN.md: Copy). */
export default function CopyButton({ text, label, copiedLabel, className = '', ariaLabel, disabled }) {
  const [copied, setCopied] = useState(false);
  const timer = useRef(null);

  useEffect(() => () => clearTimeout(timer.current), []);

  const onClick = async () => {
    if (!text) return;
    const ok = await copyText(text);
    if (!ok) return;
    setCopied(true);
    clearTimeout(timer.current);
    timer.current = setTimeout(() => setCopied(false), 2000);
  };

  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled || !text}
      aria-label={ariaLabel}
      className={`${btnSecondary} ${copied ? 'border-forest text-forest-ondark' : ''} ${className}`}
    >
      {copied ? <Check size={16} aria-hidden /> : <Copy size={16} aria-hidden />}
      <span aria-live="polite">{copied ? copiedLabel : label}</span>
    </button>
  );
}
